import lrLayout from './_src/lrLayout.vue'

lrLayout.install = function(Vue) {
  Vue.component(lrLayout.name, lrLayout)
}

export default lrLayout